module.exports = __webpack_public_path__ + "img/Floppy.16d370ac.svg";